export default __webpack_public_path__ + "static/media/logo.7b3f3c9f.png";